<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml" xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <base-page-component :has-back="false" :has-nav="false">
    <div style="background-color: #F4F8FF;height: calc(100% - 0px)">
      <div class="bg-white m-auto">
        <div class="flex a-center h-60">
          <Button @click="createNewPage()" class="m-l-25" type="primary">新建页面</Button>
          <Input class="m-l-15" placeholder="标题" style="width: 240px" v-model="searchText"/>
          <Button @click="onSearchClick" class="m-l-15">搜索</Button>
        </div>

        <div class="m-h-25 ">
          <Table :columns="columns" :data="dataList" :height="tableHeight">
            <template v-slot:copy="{row,index}">
              <div class="flex a-center">
                <Tooltip content="复制">
                  <div class=" icon-copy fs-20 m-l-5" style="color: #1472FF;cursor: pointer;" v-clipboard:copy="row.url"
                       v-clipboard:error="onError" v-clipboard:success="copy"/>
                </Tooltip>
              </div>
            </template>


            <template v-slot:link="{row,index}">
              <div class="flex a-center j-center">
                {{ row.url }}
              </div>
            </template>

            <template v-slot:status="{row,index}">
              <div class="flex a-center j-center">
                <div class="p-h-10 fs-13 flex a-center j-center p-t-2"
                     style="background-color: #EEFFEF;color: #4CAF50;border-radius: 11px;" v-if="row.status === 1">
                  已发布
                </div>
                <div class="p-h-10 fs-13 flex a-center j-center p-t-2"
                     style="background-color: #FFF3EB;color: red;border-radius: 11px;" v-if="row.status === 2">
                  未发布
                </div>
              </div>
            </template>
            <template v-slot:operation="{row,index}">
              <div class="flex j-between fs-12">
                <span @click="onPageRenovationClick(row)" style="cursor: pointer;color: #3B80FF">装修页面</span>
                <span @click="onShareSettingClick(row,index)" style="color:#3B80FF;cursor: pointer">分享设置</span>
                <!--弹窗页面标题-->
                <span @click="onStyleSettingClick(row)" style="cursor: pointer;color: #3B80FF">页面设置</span>
                <span @click="onRenameClick(row)" style="color:#3B80FF;cursor: pointer">重设名称</span>
                <span @click="delItemPage(row,index)" style="color:red ;cursor: pointer">删除页面</span>
                <span :style="{color:getStatus(row)}" @click="changeStatus(row,index)" style="cursor: pointer">{{ row.status === 1 ? '停用' : '发布' }}</span>
              </div>
            </template>
          </Table>

          <div style="padding: 10px 0">
            <Page :current.sync="tablePage.currentPage" :page-size="tablePage.pageSize" :page-size-opts="pageSizeOpts"
                  :show-total="true"
                  :total="tablePage.total" @on-change="onPageChange" @on-page-size-change="onPageSizeChange"
                  show-sizer></Page>
          </div>
        </div>
      </div>
    </div>

    <!--    新建页面弹框-->
    <Modal :closable="false" class="modal-setting" title=" " v-model="createPageModal.show" width="400px">
      <p class="text-center" slot="header">
        <span>{{ createPageModal.title }}</span>
      </p>
      <p slot="footer"></p>
      <div>
        <Input class=" m-b-10" maxlength="18" placeholder="页面名称" show-word-limit style="width: 320px"
               v-model="createPageModal.pageTitle"/>
        <div class="w-full flex j-center">
          <Button @click="createPageModalCancel">取消</Button>
          <Button @click="createPageModalOk" style="margin-left: 50px" type="primary">
            {{ createPageModal.step === 1 ? '确定' : '开始装修' }}
          </Button>
        </div>
      </div>
    </Modal>

    <!--重置名称弹框-->
    <Modal :closable="false" class="modal-setting" title=" " v-model="renameModal.show" width="400px">
      <p class="text-center" slot="header">
        <span>重置名称</span>
      </p>
      <Input :maxlength="5" class="m-b-10" maxlength="18" show-word-limit style="width: 320px"
             v-model="renameModal.name"/>
      <div>
      </div>
      <div class="w-full flex j-center" slot="footer">
        <Button @click="renameModalCancel">取消</Button>
        <Button @click="renameModalOk" style="margin-left: 50px" type="primary">确定</Button>
      </div>
    </Modal>

    <!--页面设置-->
    <Modal :closable="false" :mask-closable="false"
           @on-visible-change="onModalClose"
           class="modals"
           class-name="vertical-center-modal"
           footer-hide
           v-model="showStyleSet"
           width="680">
      <style-page-setting-widget :pageId='editPageId' @cancel="showStyleSet=false"
                                 @config="onStyleSetOK">
      </style-page-setting-widget>
    </Modal>

    <!--    分享设置弹框-->
    <Modal :closable="false" :mask-closable="false" @on-visible-change="onModalClose" class="modals"
           class-name="vertical-center-modal" footer-hide v-model="shareModal" width="550">
      <share-page-setting-widget :pageId='editPageId' @cancel="shareModal=false"
                                 @config="shareModal=false"></share-page-setting-widget>
    </Modal>
  </base-page-component>

</template>

<script>
import BasePageComponent from '@/components/common/BasePageComponent'
import UpLoadImage from '@/components/common/UpLoadImage'
import {formatTimeStamp} from '@/utils/dateUtil'
import {mapActions} from 'vuex'
import mixin from '../../../config/mixinfile'
import StylePageSettingWidget from '../../product/boot/component/StylePageSettingWidget'
import SharePageSettingWidget from '../../product/boot/component/SharePageSettingWidget'

export default {
  name: 'MaterialBasePage',
  mixins: [mixin.mixin],
  components: {
    SharePageSettingWidget,
    StylePageSettingWidget,
    BasePageComponent,
    UpLoadImage,
  },
  data () {
    return {
      showStyleSet: false,                                //风格设置
      editPageId: 0,
      isSingle: 1,                                        //固定值, 落地页1, 引导页2
      searchText: '',                                     //搜索字段
      tableHeight: 620,
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      shareModal: false,
      createPageModal: {
        show: false,
        title: '新建落地页',
        pageTitle: '',
        //第1步:确认创建按钮 , 第2步:跳转到装修页面
        step: 1,
        // 新建页面的id
        newPageId: -1,
      },
      renameModal: {                            //重命名
        show: false,
        title: '重置名称',
        name: '',
        row: {},
      },
      columns: [
        {
          title: '页面名称',
          key: 'name',
          minWidth: 400,
          tooltip: true,
        }, {
          title: '创建时间',
          key: 'createTime',
          width: 178
        }, {
          title: '状态',
          align: 'center',
          slot: 'status',
          width: 110
        }, {
          //   title: '页面链接',
          //   key: 'url',
          //   width: 400,
          //   align: 'center',
          //   tooltip: true,
          // }
          // , {
          //   title: '复制',
          //   slot: 'copy',
          //   width: 100,
          //   align: 'left'
          // }
          // , {
          title: '操作',
          slot: 'operation',
          width: 400
        }
      ],
      dataList: []
    }
  },
  activated () {
    this.setTableHeight()
    this.getListData()
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.setTableHeight()
      this.getListData()
    },
    setTableHeight(){
      this.tableHeight = window.innerHeight - 250
      window.onresize = () => {
        this.tableHeight = window.innerHeight - 250
      }
    },
    getStatus (row) {
      if (row.status === 1) {
        return 'red'
      } else {
        return 'green'
      }
    },
    copy (e) {
      this.$Message.info('复制成功')
    },
    onError (e) {
      this.$Message.info('复制失败')
    },
    onPageRenovationClick (row) {
      const {href} = this.$router.resolve({
        path: '/renovation',
        query: {
          id: row.id,
          title: row.name,
          from: 'MaterialBasePage',
          tagTitle: row.name + '装修',
        }
      })
      this.$router.push(href)
    },
    //创建页面弹框
    createNewPage () {
      this.createPageModal.step = 1
      this.createPageModal.pageTitle = ''
      this.createPageModal.show = true
    },
    //创建页面cancel
    createPageModalCancel () {
      this.createPageModal.step = 1
      this.createPageModal.show = false
    },
    createPageModalOk () {
      if (this.createPageModal.step === 1) {
        if (this.createPageModal.pageTitle) {

          let pageStyle = {
            pageBgColor: '#F8F8F9',
            navTitleColor: '#333333',
            navBgColor: 'white',
          }
          let pageExtension = {
            showNav: 0,
          }

          let params = {
            rootContentId: 6,
            isSingle: this.isSingle,
            name: this.createPageModal.pageTitle,
            title: this.createPageModal.pageTitle,
            style: JSON.stringify(pageStyle) || '',
            extension: JSON.stringify(pageExtension) || '',
            containerList: [],
            decorateMode: 1,
            jumpLink: '',
          }

          this.addPage(params).then((res) => {
            if (res.code === 0) {
              this.createPageModal.newPageId = res.data.id
              this.getListData()
              this.createPageModal.step = 2
            }
          })
        } else {
          this.$Message.info('页面名称不能为空')
        }
      } else {
        this.createPageModal.show = false
        let index = this.dataList.findIndex(value => value.id + '' === this.createPageModal.newPageId + '')
        if (index > -1) {
          this.onPageRenovationClick(this.dataList[index])
        }
      }
    },
    onShareSettingClick (row, index) {                     //点击分享设置
      this.editPageId = row.id
      this.shareModal = true
    },
    //删除页面
    delItemPage (row, index) {
      const content = '<p>确定要删除页面 <span style="color: red">' + row.name + ' </span>吗?</p>'
      this.$Modal.confirm({
        title: '提示',
        content: content,
        onOk: () => {
          this.delPage(row.id).then(res => {
            if (res.code === 0) {
              this.getListData()
            }
            if (res.msg) {
              this.$Message.info(res.msg)
            }
          })
        },
        onCancel: () => {
        }
      })
    },

    //停用 发布页面
    changeStatus (row, index) {
      const operator = row.status === 1 ? '停用' : '发布'
      var page = row.name
      this.$Modal.confirm({
        title: '提示',
        content: '确定要' + operator + '页面 <span style="color: red">' + page + '</span> 吗?',
        onOk: () => {
          this.$Message.info('此处应调发布/停用接口')
        },
        onCancel: () => {
        }
      })
    },

    //获取数据
    getListData () {
      let params = {
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.currentPage,
        isSingle: this.isSingle,
      }
      if (this.searchText) {
        params.name = this.searchText
      }
      this.getWebPageList(params).then((res) => {
        if (res.code === 0) {
          this.dataList = res.data.list.map(item => {
            return {
              id: item.id,
              name: item.name,
              url: item.link.link,
              createTime: item.createTime,
              status: 1,
              share: {
                title: '',
                picUrl: ''
              }
            }
          })
          this.tablePage.total = res.data.total
        } else {
          this.$Message.info(res.msg)
        }
      })
    },
    /**
     * 分页请求
     * @param e
     */
    onPageChange (e) {
      this.tablePage.currentPage = e
      this.getListData()
    },
    /**
     * 搜索
     * */
    onSearchClick () {
      this.tablePage.currentPage = 1
      this.getListData()
    },
    /**
     * 换页条数请求处理
     * @param e
     */
    onPageSizeChange (e) {
      this.tablePage.pageSize = e
      if (this.tablePage.currentPage === 1) {
        this.getListData()
      }
    },
    onStyleSettingClick (row) {
      this.editPageId = row.id
      this.showStyleSet = true
    },
    onStyleSetOK () {
      this.getListData()
      this.showStyleSet = false
    },
    onModalClose (status) {
      if (!status) {
        this.editPageId = 0
      }
    },
    onRenameClick (row) {                         //重置名称
      this.renameModal = {
        show: true,
        name: row.name,
        row: row,
      }
    },
    renameModalCancel () {                        //重置名称 确认
      this.renameModal.show = false
    },
    renameModalOk () {                            ////重置名称 取消
      if (!this.renameModal.name) {
        this.$Message.info('名称不能为空')
        return
      }
      let params = {
        name: this.renameModal.name
      }
      this.editPageBase({
        id: this.renameModal.row.id,
        params
      }).then(res => {
        if (res.code === 0) {
          this.getListData()
          this.renameModal.show = false
        }
        if (res.msg) {
          this.$Message.info(res.msg)
        }
      })
    },

    ...mapActions([
      'addPage',
      'getWebPageList',
      'delPage',
      'editPageBase'
    ])
  }
}
</script>

<style lang="scss" scoped>
  .modal-setting ::v-deep {

    .ivu-modal-body {
      padding: 0;
      display: flex;
      justify-content: center;
      align-content: center;
    }

    //标题下横线
    .ivu-modal-header {
      border-bottom: none;
    }

    //确认取消按钮上面红线
    .ivu-modal-footer {
      border-top: none;
    }
  }
</style>
<style scoped>
  .modals >>> .ivu-modal-body {
    padding: 0;
  }

  .tablePtye >>> .ivu-table-cell {
    padding-left: 5px;
    padding-right: 5px;
  }

  /*.modals >>> .ivu-modal-content {*/
  /*border-bottom-left-radius: 0px;*/
  /*border-bottom-right-radius: 0px;*/
  /*}*/
</style>
